import React from "react";
import {Box, Grid, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {VideoPreview} from "../../../../../components";

const AdditionalWorkList = (props) => {
	const {
		data,
		onOpenDialogImagesVideos,
		onOpenDialogImagesMessage,
		isFilesLoading
	} = props;
	const classes = useStyles();

	if (!data || data.length < 1) {
		return null;
	}

	return (
		<Grid className={classes.root} container spacing={2}>
			{data.map((work) => (
				<Grid key={`additional-work-${work.id}`} item xs={12} lg={6}>
					<AdditionalWorkCard
						work={work}
						onOpenDialogImagesVideos={onOpenDialogImagesVideos}
						onOpenDialogImagesMessage={onOpenDialogImagesMessage}
						isFilesLoading={isFilesLoading}
					/>
				</Grid>
			))}
		</Grid>
	);
};

const AdditionalWorkCard = (props) => {
	const {
		work,
		isFilesLoading,
		onOpenDialogImagesVideos,
		onOpenDialogImagesMessage
	} = props;
	const classes = useStyles();

	const handleOpenDialogImagesMessage = (index) => {
		onOpenDialogImagesMessage({
			index,
			files: work.pictures || [],
			message: work?.description || ""
		});
	};

	return (
		<Box className={classes.orderCard}>
			<Box className={classes.orderCardHead}>
				<div
					className={classes.orderCardName}
					dangerouslySetInnerHTML={{
						__html: work.description
					}}
				/>
			</Box>
			<Box className={classes.orderCardBody}>
				<Box className={classes.orderCardInfo}>
					{Boolean(work.quantity && work.unit) && (
						<Typography className={classes.orderCardDetail}>
							Количество: {work.quantity} {work.unit}
						</Typography>
					)}
					{Boolean(work.cost) && (
						<Typography className={classes.orderCardDetail}>
							Стоимость: {Number.parseFloat(work.cost).toLocaleString('ru-RU')} ₽
						</Typography>
					)}
				</Box>
				{Boolean((work.pictures || []).length > 0) && (
					<Grid className={classes.files} container spacing={1}>
						{(work.pictures || []).map((file, index) => {
							const isVideo = Boolean((file?.mimetype || '').includes("video"));
							if (!!isVideo) {
								return (
									<Grid item key={`additional-work-video-${file.id}`}>
										<VideoPreview
											file={file}
											onClick={handleOpenDialogImagesMessage.bind(this, index)}
										/>
									</Grid>
								);
							}
							return (
								<Grid item key={`additional-work-photo-${file.id}`}>
									<img
										src={file.url}
										onClick={handleOpenDialogImagesMessage.bind(this, index)}
									/>
								</Grid>
							);
						})}
					</Grid>
				)}
			</Box>
		</Box>
	);
};

const useStyles = makeStyles(() => ({
	root: {
		"@media(max-width: 1199px)": {
			paddingBottom: 100
		}
	},
	orderCard: {
		display: "flex",
		flexDirection: "column",
		height: "100%",

		padding: 20,
		boxSizing: "border-box",
		boxShadow: "0px 2px 8px rgba(142, 150, 168, 0.24)",
		backgroundColor: "white",
		borderRadius: 4,

		"@media(max-width: 1199px)": {
			padding: 12,
		}
	},
	orderCardHead: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		marginBottom: 12
	},
	orderCardBody: {
		marginBottom: 16
	},
	orderCardName: {
		fontSize: 20,
		lineHeight: "24px",
		color: "black",
		fontWeight: "500",

		"@media(max-width: 1199px)": {
			fontSize: 18,
			lineHeight: "20px",
		}
	},
	orderCardInfo: {
		marginBottom: 12
	},
	orderCardDetail: {
		"&.MuiTypography-root": {
			fontSize: 14,
			lineHeight: "20px",
			color: "rgba(0,0,0,0.7)",
		}
	},
	files: {
		"& > * > *": {
			width: 60,
			height: 60,
			borderRadius: 4,
			overflow: "hidden",
			border: "1px solid red",
			objectFit: "contain"
		}
	},
}));

export default React.memo(AdditionalWorkList);
